<div class="bg-white w-full">
  <!-- Breadcrumb -->
  <div class="w-full px-4 sm:px-6 lg:px-8 pt-2 md:pt-4 bg-white">
    <app-breadcrum
      [data]="breadcrumbData"
      (breadcrumbClick)="onBreadcrumbClick($event)"
    >
    </app-breadcrum>
  </div>

  <!-- Main Content Container -->
  <div
    *ngIf="blogItem"
    class="mx-auto px-4 sm:px-6 lg:px-8 mt-2 md:mt-4 mb-6 lg:mb-8 w-full"
  >
    <div class="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8 lg:items-start">
      <!-- Main Content Area (Left) - Scrollable with hidden scrollbar -->
      <div
        class="w-full lg:col-span-8 xl:col-span-8 flex flex-col gap-4 sm:gap-4 lg:order-1 lg:overflow-y-auto lg:max-h-[calc(100vh-140px)] lg:pr-4 custom-blog-scroll scrollbar-hide no-scrollbar"
      >
        <!-- Hero Image -->
        <div
          *ngIf="hasImage(blogItem)"
          class="relative w-full h-48 sm:h-64 md:h-80 lg:h-[450px] xl:h-[500px] rounded-2xl overflow-hidden shrink-0"
        >
          <img
            [src]="
              blogItem.images && blogItem.images.length > 0
                ? blogItem.images[0]
                : ''
            "
            [alt]="blogItem.title"
            class="object-cover w-full h-full"
          />
        </div>

        <!-- Placeholder if no image -->
        <div
          *ngIf="!hasImage(blogItem)"
          class="relative w-full h-48 sm:h-64 md:h-80 lg:h-[450px] xl:h-[500px] rounded-2xl overflow-hidden bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center shrink-0"
        >
          <p class="text-gray-500 text-lg">No Image Available</p>
        </div>

        <!-- Article Title -->
        <span
          class="text-2xl sm:text-xl max-md:text-xl font-bold text-Neutrals-Black leading-tight line-clamp-2"
        >
          {{ blogItem.title }}
        </span>

        <!-- Metadata -->
        <div
          class="flex flex-wrap items-center gap-2 text-sm sm:text-base text-[#777777] font-medium"
        >
          <span>{{ formatDate(blogItem.created_date) }}</span>
          <span *ngIf="readTime">, {{ readTime }}</span>
          <span *ngIf="blogItem.author_name">, {{ blogItem.author_name }}</span>
        </div>

        <!-- Article Body -->
        <div
          class="prose prose-lg max-w-none text-Neutrals-Black leading-relaxed"
        >
          <div
            [innerHTML]="getSanitizedDescription()"
            class="blog-content text-base sm:text-lg"
          ></div>
        </div>

        <!-- About Section (if author_description exists) -->
        <div
          *ngIf="blogItem.author_description"
          class="mt-2 rounded-lg"
        >
          <h3 class="text-xl font-bold text-Neutrals-Black mb-4">
            About {{ blogItem.author_name || 'Tata Motors' }}
          </h3>
          <p class="text-base text-Neutrals-Black leading-relaxed">
            {{ blogItem.author_description }}
          </p>
        </div>
      </div>

      <!-- Recent Blogs Section (Right) - Fixed/Sticky with hidden scrollbar -->
      <div
        class="w-full lg:col-span-4 xl:col-span-4 lg:order-2 lg:sticky lg:top-24 lg:self-start recent-blogs-sidebar"
      >
        <div class="bg-white rounded-lg p-4 md:p-4 lg:p-2 shadow-sm lg:max-h-[calc(100vh-140px)] lg:overflow-y-auto custom-blog-scroll scrollbar-hide no-scrollbar">
          <h2
            class="text-lg md:text-xl lg:text-2xl font-bold text-Neutrals-Black mb-4 md:mb-6"
          >
            Recent Blogs
          </h2>

          <div class="flex flex-col gap-4 md:gap-6">
            <div
              *ngFor="let blog of recentBlogs"
              class="flex flex-row gap-3 cursor-pointer hover:opacity-80 transition-opacity group"
              (click)="navigateToBlog(blog)"
            >
              <!-- Blog Image -->
              <div
                class="relative w-24 h-20 sm:w-28 sm:h-24 md:w-32 md:h-28 lg:w-40 lg:h-32 flex-shrink-0 rounded-xl overflow-hidden"
              >
                <img
                  *ngIf="hasImage(blog)"
                  [src]="
                    blog.images && blog.images.length > 0 ? blog.images[0] : ''
                  "
                  [alt]="blog.title"
                  class="object-cover w-full h-full group-hover:scale-105 transition-transform duration-300"
                />
                <div
                  *ngIf="!hasImage(blog)"
                  class="w-full h-full bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center"
                >
                  <p class="text-gray-500 text-xs">No Image</p>
                </div>
              </div>

              <!-- Blog Text Content -->
              <div class="flex flex-col gap-1 md:gap-2 flex-1 min-w-0">
                <!-- Blog Title -->
                <h5
                  class="text-sm md:text-base lg:text-lg font-medium text-Neutrals-Black leading-snug line-clamp-2"
                >
                  {{ blog.title }}
                </h5>

                <!-- Blog Metadata -->
                <p class="text-xs md:text-sm text-[#777777] font-medium">
                  {{ formatDate(blog.created_date) }}
                  <span *ngIf="blog.author_name">, {{ blog.author_name }}</span>
                </p>
              </div>
            </div>
          </div>

          <!-- Show message if no recent blogs -->
          <div
            *ngIf="recentBlogs.length === 0"
            class="text-center text-gray-500 py-4"
          >
            No recent blogs available
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Not Found / Error State when not loading and no blogItem -->
  <div
    *ngIf="!isLoading && !blogItem"
    class="mx-auto px-4 sm:px-6 lg:px-8 py-16 flex flex-col items-center justify-center text-center"
  >
    <div
      class="w-20 h-20 mb-4 rounded-full bg-blue-50 flex items-center justify-center text-blue-500"
    >
      <svg
        class="w-10 h-10"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"
        ></path>
      </svg>
    </div>
    <h2 class="text-2xl font-bold text-gray-900 mb-2">Blog Not Found</h2>
    <p class="text-base text-gray-600 mb-6 max-w-md">
      The blog article you are looking for could not be found or may have been removed.
    </p>
    <button
      type="button"
      (click)="navigateToBlogStories()"
      class="inline-flex items-center gap-2 px-6 py-2.5 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg shadow-sm transition-colors cursor-pointer"
    >
      <svg
        class="w-4 h-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M10 19l-7-7m0 0l7-7m-7 7h18"
        ></path>
      </svg>
      Back to Blogs & Stories
    </button>
  </div>
</div>
